<template>
  <documents-table
    :headers="_headers"
    :items="gapsInService"
    zipFileName="Gaps_In_Service.zip"
    groupName="formattedGapDate"
    groupBy="gapDate"
    groupDesc
  >
    <template v-slot:toggle>
      <v-col cols="12" sm="2"
        ><v-switch
          v-if="!withinClientChart"
          v-model="awaitingSubmissionOnly"
          label="Awaiting Submission"
        ></v-switch>
      </v-col>
    </template>
    <template v-slot:actionButton="{ selectedItems, clearSelected }">
      <v-col cols="12" sm="2" :class="isMobile ? null : 'pt-4'">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <div v-on="on">
              <v-btn
                v-if="!withinClientChart"
                small
                color="primary"
                :dark="!disableSubmit(selectedItems)"
                :disabled="disableSubmit(selectedItems)"
                @click="
                  submitGapsInService(selectedItems);
                  clearSelected();
                "
                ><v-icon left> mdi-check-circle </v-icon> Mark Submitted
              </v-btn>
            </div></template
          ><span>{{
            disableSubmit(selectedItems)
              ? "One or more selected items have already been submitted"
              : "Mark Submitted"
          }}</span></v-tooltip
        ></v-col
      >
    </template>
    <template v-slot:checkbox="{ item }">
      <v-icon color="success" v-if="Boolean(item.sentToServiceCoordinator)"
        >mdi-check-bold
      </v-icon>
    </template>
  </documents-table>
</template>

<script>
import DocumentsTable from "../../Client/Details/documents-table";
export default {
  props: ["clientId"],
  components: { DocumentsTable },
  data() {
    return {
      awaitingSubmissionOnly: false,
    };
  },
  async mounted() {
    if (!this.withinClientChart) {
      this.$store.commit("uxModule/setShowLoader", true);
      await this.$store.dispatch("clientModule/getAllGapsInService");
      this.$store.commit("uxModule/setShowLoader", false);
    }
  },
  computed: {
    withinClientChart() {
      return Boolean(this.clientId);
    },
    isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },
    _headers() {
      var headers = [
        {
          text: "Provider Name",
          value: "providerName",
        },
        {
          text: "Client Name",
          value: "clientName",
          hide: this.withinClientChart,
        },
        {
          text: "Service",
          value: "service",
        },
        {
          text: "Sent to Service Coordinator",
          value: "sentToServiceCoordinator",
          align: "center",
          sortable: false,
        },
      ];
      return headers.filter((x) => !x.hide);
    },
    providerId() {
      return this.$store.state.sharedModule.providerId;
    },
    gapsInService() {
      var gaps = this.$store.state.clientModule.gapsInService ?? [];
      return this.awaitingSubmissionOnly
        ? gaps.filter((item) => !item.sentToServiceCoordinator)
        : gaps;
    },
  },
  methods: {
    disableSubmit(selectedItems) {
      return (
        selectedItems.length < 1 ||
        selectedItems.some((item) => item.sentToServiceCoordinator)
      );
    },
    async submitGapsInService(selectedItems) {
      this.$store.commit("uxModule/setShowLoader", true);
      var ids = selectedItems.map((item) => item.gapInServiceId);
      await this.$store.dispatch("clientModule/setGapsInServiceSentToSC", {
        ids: ids,
      });
      this.$store.commit("uxModule/setShowLoader", false);
    },
  },
};
</script>